module.exports = __webpack_public_path__ + "img/1590558474.86eaa6b2.jpg";